// src/pages/jobs/jobsData.js
const jobsData = [
  {
    id: 1,
    program: "کمپیوتر ساینس",
    department: "تکنالوژی معلوماتی",
    title: "استاد تکنالوژی معلوماتی",
    level: "لیسانس الی دوکتور",
    vacancies: 2,
    province: "کابل",
    university: "میوند",
    description:
      "تدریس مضامین مربوط به تکنالوژی معلوماتی، اشتراک در فعالیت‌های علمی و تطبیق نصاب تحصیلی.",
  },
  {
    id: 2,
    program: "کمپیوتر ساینس",
    department: "انجنیری کمپیوتر",
    title: "استاد انجنیری کمپیوتر",
    level: "لیسانس الی دوکتور",
    vacancies: 2,
    province: "کابل",
    university: "میوند",
    description:
      "تدریس مضامین انجنیری کمپیوتر، اشتراک در تحقیقات علمی و امور اکادمیک.",
  },
  {
    id: 3,
    program: "اقتصاد",
    department: "اداره و تجارت",
    title: "استاد اداره و تجارت",
    level: "لیسانس الی دوکتور",
    vacancies: 2,
    province: "کابل",
    university: "میوند",
    description: "تدریس مضامین اداره و تجارت و سهم‌گیری در امور علمی پوهنځی.",
  },
  {
    id: 4,
    program: "اقتصاد",
    department: "منجمنت",
    title: "استاد منجمنت",
    level: "لیسانس الی دوکتور",
    vacancies: 2,
    province: "کابل",
    university: "میوند",
    description: "تدریس مضامین منجمنت مطابق نصاب تحصیلی.",
  },
  {
    id: 5,
    program: "تعلیم و تربیه",
    department: "تعلیمات اسلامی",
    title: "استاد تعلیمات اسلامی",
    level: "لیسانس الی دوکتور",
    vacancies: 2,
    province: "کابل",
    university: "میوند",
    description: "تدریس مضامین تعلیمات اسلامی و اشتراک در فعالیت‌های تربیوی.",
  },
  {
    id: 6,
    program: "تعلیم و تربیه",
    department: "ادبیات دری",
    title: "استاد ادبیات دری",
    level: "لیسانس الی دوکتور",
    vacancies: 2,
    province: "کابل",
    university: "میوند",
    description: "تدریس مضامین ادبیات دری و انجام تحقیقات ادبی.",
  },
  {
    id: 7,
    program: "تعلیم و تربیه",
    department: "تاریخ",
    title: "استاد تاریخ",
    level: "لیسانس الی دوکتور",
    vacancies: 2,
    province: "کابل",
    university: "میوند",
    description: "تدریس مضامین تاریخ و سهم‌گیری در امور اکادمیک.",
  },
  {
    id: 8,
    program: "تعلیم و تربیه",
    department: "ریاضی",
    title: "استاد ریاضی",
    level: "لیسانس الی دوکتور",
    vacancies: 2,
    province: "کابل",
    university: "میوند",
    description: "تدریس مضامین ریاضی مطابق نصاب تحصیلی.",
  },
];

export default jobsData;
